import type { FaireProductEntity } from "../../entity_types/product";

export const p_mb3b9wh8kd: FaireProductEntity = {
  token: "p_mb3b9wh8kd",
  type: "product",
  name: "Ivory Gold Ombré Beaded Crystal Winged Statement Earrings",
  brandToken: "b_vjqfbthsp3",
  brandName: "Brookhaven Baubles",
  imageUrl: "https://cdn.faire.com/fastly/7c6665daa88cef412ceedcdae22867b54ecf65423556c5cbe7a1bf06d70c0d9d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/37f6f4c93e380e9b1e1ddc35b620c1cc4e1ec223294e7c0fbf0f93e8b100df17.jpeg",
    "https://cdn.faire.com/fastly/bde4e76a6cc73d5bfa346bf55f9f48f55b396fb8d3911ab1100ddf902900d480.jpeg",
    "https://cdn.faire.com/fastly/63ba4cb2b91347ecd81e6c2ee045c30ef1693d953b8e73a7fca7a032d603d7ce.jpeg"
  ],
  priceDollars: 14,
  description: "Ivory and Gold Ombré Beaded Crystal Winged Statement Earrings - Southern Statement Jewelry - Beaded Statement Earrings - Fashion Earrings\n\nBeautiful ivory and gold colored ombré wing statement earrings and glass crystals outlined in ivory seed beads. These statement earrings are for pierced ears and are 2.5 inches long.\n\nThese earrings are made from lightweight materials, acrylic seed beads and crystals and you will practically forget you are wearing them.\n\nOur earrings are the perfect statement for any occasion or outfit! Perfect for every occasion, from casual days to special events like weddings and birthdays.\n\nAll posts are lead and nickel-free and very lightweight for easy everyday wear.\n\n\n\nAll images are copyrighted by Brookhaven Baubles. All rights reserved.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T16:32:06.429Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
